import React, { useEffect, useState } from 'react';
import useSiteState from '@app/state/SiteState';
import FormButton from '@app/component/form/button/FormButton';
import SecurityService from '@app/model/_security/service/SecurityService';
import useToaster from '@app/component/overlays/toaster/ToasterHook';
import { useGoogleLogin } from '@react-oauth/google';
import AuthProvider from '@app/model/authentication/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from '@app/component/translation/Translation';

const SocialLoginFragment: React.FunctionComponent<{ onPending: (isPending: boolean) => void }> = ({ onPending }) => {

	const siteState = useSiteState();
	const [isPending, setIsPending] = useState<boolean>(false);
	const toaster = useToaster();
	const navigate = useNavigate();
	const {t} = useTranslation();

	useEffect(() => {
		onPending(isPending);
	}, [isPending, onPending]);

	const socialLoginMutation = useMutation({
		mutationFn: SecurityService.socialSignIn,
		onSuccess: (principalWithToken) => {
			SecurityService.login(principalWithToken);
			navigate('/oauth2/redirect')
		},
		onError: (error: any) => {
			toaster.error('Google Sign In:', t(error.message || error || 'server.exception.authentication.GOOGLE_SIGN_IN_FAILED'));
		},
		onMutate: () => {
			siteState.logout();
			SecurityService.removeToken()
			setIsPending(true);
		},
		onSettled: () => {
			setIsPending(false);
		}
	})

	const googleLogin = useGoogleLogin({
		onSuccess: (tokenResponse) => socialLoginMutation.mutate({authProvider: AuthProvider.GOOGLE, authProviderResponse: tokenResponse}),
		onError: () => console.error('Google login failed'),
		flow: 'implicit',

	});

	return <div className="mt-6">
		<div className="relative">
			<div className="absolute inset-0 flex items-center" aria-hidden={true}>
				<div className="w-full border-t border-gray-200" />
			</div>
			<div className="relative flex justify-center text-sm font-medium leading-6">
				<span className="bg-white px-6 text-gray-900">Or continue with</span>
			</div>
		</div>
		<div className="mt-12 grid">
			<div>
				<FormButton
					state="white"
					onClick={() => googleLogin()}
					extraClassName="w-full"
					isLoading={isPending}
					icon={
						<img
							className="h-4 w-4 mr-1.5"
							src="/assets/img/logos/google-icon.svg"
							alt="Sign in with Google"
						/>
					}
				>
					Google
				</FormButton>
			</div>
		</div>
	</div>;
};

export default SocialLoginFragment;